import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import WorkView from '../components/stores/WorkView.vue'
import StoresIndex from '../components/stores/StoresIndex.vue'
//Translations

export default /*#__PURE__*/_defineComponent({
  __name: 'PageStores',
  setup(__props) {

const { t } = useI18n({ useScope: 'global' })
const storeItemsLabel = (key: string) => t(`tables.${key}`)

//Tabs
const tab = ref('workView')

//WorkView

return (_ctx: any,_cache: any) => {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-pt-sm" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_tabs, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
        class: "text-grey",
        "active-color": "secondary",
        "indicator-color": "secondary",
        align: "left",
        "narrow-indicator": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab, {
            name: "workView",
            label: storeItemsLabel('workView')
          }, null, 8, ["label"]),
          _createVNode(_component_q_tab, {
            name: "stores",
            label: storeItemsLabel('stores')
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_separator),
      _createVNode(_component_q_tab_panels, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event)),
        "keep-alive": "",
        animated: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab_panel, {
            "keep-alive": "",
            name: "workView"
          }, {
            default: _withCtx(() => [
              _createVNode(WorkView, { key: "workView" })
            ]),
            _: 1
          }),
          _createVNode(_component_q_tab_panel, {
            "keep-alive": "",
            name: "stores"
          }, {
            default: _withCtx(() => [
              _createVNode(StoresIndex, { key: "storeIndex" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})